import { render, staticRenderFns } from "./SpectrumPC.vue?vue&type=template&id=b2d6d224&scoped=true&"
import script from "./SpectrumPC.vue?vue&type=script&lang=js&"
export * from "./SpectrumPC.vue?vue&type=script&lang=js&"
import style0 from "./SpectrumPC.vue?vue&type=style&index=0&id=b2d6d224&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d6d224",
  null
  
)

export default component.exports